export default __webpack_public_path__ + "static/media/flexible_arbeitszeit.c65aec8a.svg";